import { RemoteApiError } from "../useRemote/types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { useTranslation } from "react-i18next";

type UpdateBookingVisitorsDto = {
  noPlaceZoneBookingId: number;
  conferenceZoneBookingGuests: {
    userId: string;
    isRequired: boolean;
    external: boolean;
    email?: string;
  }[];
};

export function useRemoteUpdateBookingVisitors() {
  const { t } = useTranslation();

  return useRemoteMutation<void, RemoteApiError, UpdateBookingVisitorsDto>({
    key: "useRemoteUpdateBookingVisitors",
    method: "put",
    url: `/booking-schedule/no-place-zone-booking-guests`,
    snackbarTextOnSuccess: t("EditVisitorsSuccess"),
    snackbarTextOnFail: t("EditVisitorsFail")
  });
}
